import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UserIdLinkProps {
  userId: string;
  children: React.ReactNode;
}

export function UserIdLink({ userId, children }: UserIdLinkProps) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/user?search=${encodeURIComponent(userId)}`);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick(e as unknown as React.MouseEvent)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: 'pointer',
        color: 'inherit',
        textDecoration: isHovered ? 'underline' : 'none',
      }}
    >
      {children}
    </span>
  );
}
